import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/base/SEO';
import { blogs } from '../../data/blogs';
import { Link } from 'react-router-dom';

export default function BlogsPage() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-900 transition-colors duration-300 relative overflow-hidden">
      <SEO 
        title="Blogs | Designs by DMI" 
        description="Read the latest insights and news from Designs by DMI on drafting, takeoff, and programming services." 
      />
      
      {/* Dynamic Background Elements */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-[#e18033]/20 dark:bg-[#e18033]/10 blur-[120px]"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-[#0d9488]/20 dark:bg-[#0d9488]/10 blur-[120px]"></div>
      </div>

      <div className="relative z-10 flex flex-col min-h-screen">
        <Header />
        
        <main className="flex-grow py-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20 relative">
              <h1 className="text-5xl md:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-gray-600 dark:from-white dark:to-gray-400 mb-6 tracking-tight">
                Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#e18033] to-[#ffaa66]">Insights</span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto font-light">
                Discover expert advice, industry trends, and the latest news from the DMI team.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
              {blogs.map((blog) => (
                <Link 
                  to={`/blog/${blog.slug}`} 
                  key={blog.id}
                  className="group relative flex flex-col rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 bg-white/70 dark:bg-gray-900/60 backdrop-blur-xl border border-white/20 dark:border-gray-700/50"
                >
                  <div className="h-64 overflow-hidden relative">
                    <div className="absolute inset-0 bg-gray-900/20 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
                    <img 
                      src={blog.coverImage} 
                      alt={blog.title} 
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute top-4 left-4 z-20">
                      <span className="px-4 py-1.5 bg-white/90 dark:bg-gray-900/90 backdrop-blur-md rounded-full text-xs font-bold text-[#e18033] tracking-wider uppercase shadow-sm">
                        Featured
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-8 flex flex-col flex-grow">
                    <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 mb-4 space-x-6">
                      <span className="flex items-center font-medium"><i className="ri-calendar-line mr-2 text-[#0d9488]"></i> {blog.date}</span>
                      <span className="flex items-center font-medium"><i className="ri-user-line mr-2 text-[#0d9488]"></i> {blog.author}</span>
                    </div>
                    
                    <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 group-hover:text-[#e18033] transition-colors leading-tight">
                      {blog.title}
                    </h3>
                    
                    <p className="text-gray-600 dark:text-gray-300 mb-8 flex-grow line-clamp-3 leading-relaxed">
                      {blog.excerpt}
                    </p>
                    
                    <div className="mt-auto pt-4 border-t border-gray-100 dark:border-gray-800 flex items-center justify-between">
                      <span className="text-[#e18033] font-bold flex items-center group-hover:tracking-wider transition-all duration-300">
                        Read Article 
                      </span>
                      <div className="w-10 h-10 rounded-full bg-[#e18033]/10 dark:bg-[#e18033]/20 flex items-center justify-center group-hover:bg-[#e18033] group-hover:text-white text-[#e18033] transition-all duration-300 transform group-hover:translate-x-1">
                        <i className="ri-arrow-right-line"></i>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </main>
        
        <Footer />
      </div>
    </div>
  );
}
